
webpack.register(
    'modules/tag-based-related-content/tag-based-related-content',
    function() {
        return import('modules/tag-based-related-content/tag-based-related-content');
    },
    true
);